// functions to center a select on safari
// impossible to center select text via css alone
// this checks for safari and then uses the functions below to add text indent based on the space of the various options in the select

function getTextWidth(txt) {
  var $elm = $('<span class="tempforSize">' + txt + '</span>').prependTo(
    'body'
  );
  var elmWidth = $elm.width();
  $elm.remove();
  return elmWidth;
}
function centerSelect($elm) {
  var optionWidth = getTextWidth($elm.children(':selected').html());
  var emptySpace = $elm.width() - optionWidth;
  $elm.css('text-indent', emptySpace / 2 + 2); // -10 for some browers to remove the right toggle control width
}
function normaliseSelect($elm) {
  $elm.css('text-indent', 0);
}

// check if user is on safari to target select centering only for this browser

var ua = navigator.userAgent.toLowerCase();
console.log('[USER AGENT]', ua);
var isSafari = false;
if (ua.indexOf('safari') != -1) {
  if (ua.indexOf('chrome') > -1) {
    // Chrome
  } else {
    // Safari
    isSafari = true;

    // on start
    if ($(window).innerWidth() < 901) {
      $('#sort-by').each(function () {
        centerSelect($(this));
      });
    }
  }
}

// Need to call these functions based on device width to switch between the two
// Using a switch based execution so it only runs once for each width mentioned below so performance is not affected on resize

var check = true;

$(window).resize(function () {
  if (isSafari && window.innerWidth > 916) {
    if (check) {
      $('#sort-by').each(function () {
        normaliseSelect($(this));
      });
      check = false;
    }
  } else if (isSafari && window.innerWidth < 916) {
    if (!check) {
      $('#sort-by').each(function () {
        centerSelect($(this));
      });
      check = true;
    }
  }
});
